'use strict';

const libWorkspace = require('pict-section-workspace');

/**
 * AssetTypeWorkspaceProvider — the engine behind the unified AssetType workspace
 * (#/AssetType/Workspace/:ID[/:Tab]), bridged over /PSRS/AssetType/View/:GUID. It folds the asset type's
 * three former screens into one page:
 *   • Overview       — inline edit of Name / Description (the master-list columns).
 *   • Metadata Shape — embeds the existing AssetTypeDescriptor editor (authoring + display tailoring),
 *                      scoped to this type via openInto(IDAssetType). See [[AssetTypeDescriptor-Provider.js]].
 *
 * The legacy flat #/AssetTypeManifests editor is retired; everything an admin needs for a type now lives
 * here. Config in [[AssetType.config.js]]; modeled on [[AssetWorkspace-Provider.js]].
 */
class AssetTypeWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._ovMsg = ''; this._ovErr = ''; this._ovSaving = false;
	}

	_val(pSel) { const CA = this.pict.ContentAssignment; const el = CA && CA.getElement(pSel); return (el && el.length) ? el[0].value : ''; }
	get _canEdit() { return this.can('AssetType', 'Update') || this.can('AssetType', 'Create'); }

	_overviewHTML()
	{
		const a = this._record || {};
		const ro = !this._canEdit;
		const tmpMsg = this._ovMsg ? `<div class="atw-msg">${ this._esc(this._ovMsg) }</div>` : '';
		const tmpErr = this._ovErr ? `<div class="atw-err">${ this._esc(this._ovErr) }</div>` : '';
		return `${ tmpErr }${ tmpMsg }<div class="atw-form">
			<div class="atw-field"><span class="atw-label">Name</span><input id="ATW-Name" class="atw-in" ${ ro ? 'disabled' : '' } value="${ this._esc(a.Name || '') }"></div>
			<div class="atw-field"><span class="atw-label">Description</span><textarea id="ATW-Desc" class="atw-in atw-ta" ${ ro ? 'disabled' : '' }>${ this._esc(a.Description || '') }</textarea></div>
			${ ro ? '<div class="atw-hint">Read-only — editing an asset type needs a super-user or customer-admin.</div>' : `<div class="atw-actions"><button class="atw-btn" ${ this._ovSaving ? 'disabled' : '' } onclick="_Pict.providers.AssetTypeWorkspace.saveOverviewAsync()">${ this._ovSaving ? 'Saving…' : 'Save' }</button></div>` }
		</div>
		<div class="atw-note"><i class="fas fa-circle-info"></i> Define this type's custom properties and how they display on the <b>Metadata Shape</b> tab.</div>`;
	}

	async saveOverviewAsync()
	{
		if (this._ovSaving || !this._canEdit || !this.idRecord) { return; }
		// Read the inputs BEFORE repainting — repaintBody rebuilds the fields from _record and would discard the edits.
		const tmpName = String(this._val('#ATW-Name') || '').trim();
		const tmpDesc = String(this._val('#ATW-Desc') || '');
		this._ovSaving = true; this._ovErr = ''; this._ovMsg = ''; this.repaintBody();
		// NO IDCustomer in the payload — the server stamps it from the session.
		const r = await this._putJSON('AssetType', { IDAssetType: this.idRecord, Name: tmpName, Description: tmpDesc });
		this._ovSaving = false;
		if (r && r.error) { this._ovErr = `Save failed: ${ (r.error && r.error.message) || r.error }`; this.repaintBody(); return; }
		this._record.Name = tmpName; this._record.Description = tmpDesc; this._ovMsg = 'Saved.';
		this.renderWorkspace();
	}
}

module.exports = AssetTypeWorkspaceProvider;
module.exports.default_configuration = { ProviderIdentifier: 'AssetTypeWorkspace', AutoInitialize: true, AutoInitializeOrdinal: 231 };
